import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { AuthContext } from './AuthWrapper';

const Navigation = () => {
  const { isAdmin, logout } = useContext(AuthContext);
  
  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/timeline', label: 'Timeline' },
    { path: '/exhibits', label: 'Exhibits' },
    { path: '/audio-transcripts', label: 'Audio + Transcripts' },
    { path: '/legal-claims', label: 'Legal Claims' },
    { path: '/letters-affidavits', label: 'Letters & Affidavits' },
  ];

  // Add admin dashboard link if user is admin
  if (isAdmin) {
    navItems.push({ path: '/admin', label: 'Admin Dashboard' });
  }

  return (
    <nav className="brand-nav py-3 px-4 shadow-md sticky top-0 z-10">
      <div className="max-w-6xl mx-auto flex flex-wrap items-center justify-between">
        <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4">
          {navItems.map((item, index) => (
            <NavLink
              key={index}
              to={item.path}
              className={({ isActive }) =>
                `px-3 py-2 rounded-lg transition-colors hover:bg-opacity-70 ${
                  isActive ? 'bg-opacity-100 font-bold bg-blue-600' : 'bg-transparent'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>
        
        <div>
          <button
            onClick={logout}
            className="px-3 py-2 rounded-lg transition-colors hover:bg-red-600 bg-gray-700 text-white"
            title="Logout"
          >
            Logout <span className="ml-1">→</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;